import PropTypes from 'prop-types'
import React from 'react'
import styles from './style.module.scss'
import { Col, Row } from 'react-bootstrap'

function CommonFooter({ logo, sgMedia, description, links = [], socialLinks = [], appLinks = [], connectText = 'Connect With Us', downloadText = 'Download App', CustomLink, MyImage, pageRouterComp }) {
  return (
        <footer className={`${styles.siteFooter} text-center text-sm-start`} id="footer">
            <div className="container">
                <div className={`${styles.footerBottom}`}>
                    <Row>
                        {/* <Col xl={7} lg={6}> */}
                        <Col>
                            <Row>
                                <Col xl={6} lg={7} sm={6}>
                                    <div className={`${styles.logoBlock}`}>
                                        <div className='d-flex align-items-center justify-content-center justify-content-sm-start mb-2 mx-5'>
                                            <div className={`${styles.footerLogo} d-inline-block`}>
                                                <MyImage src={logo} alt="logo" layout="responsive" />
                                            </div>
                                            <div className={styles.sgLogo} style={{ width: '50px', height: '50px' }}>
                                                <MyImage src={sgMedia} alt="SG media" width={100} height={120} style={{ marginLeft: '10px' }} />
                                            </div>
                                        </div>
                                        <p>{description}</p>
                                    </div>
                                </Col>
                                <Col xl={5} lg={7} sm={5} className='offset-xl-1'>
                                    <ul className={`${styles.footerMenu} mt-3 mt-sm-0 d-flex flex-wrap`}>
                                        {links.map(({ label, href }, i) => (
                                            <li key={i}>
                                                {pageRouterComp ? <CustomLink href={href} prefetch={false}><a>{label}</a></CustomLink> : <CustomLink href={href} prefetch={false}>{label}</CustomLink>
                                                }
                                            </li>
                                        ))}
                                    </ul>
                                </Col>
                            </Row>
                        </Col>
                        <Col xl={4} lg={6}>
                            <Row>
                                <Col lg={6} sm={6}>
                                    <p className="mt-4 mt-lg-0 mb-2 mb-sm-3">{connectText}</p>
                                    <ul className={`${styles.socialMenu} d-flex text-uppercase justify-content-center justify-content-sm-start`}>
                                        {socialLinks.map(({ icon, href, alt }, i) => (
                                            <li key={i}>
                                                <a href={href} target="_blank" rel="noreferrer">
                                                    <MyImage src={icon} alt={alt} height={110} width={110}/>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </Col>
                                <Col lg={6} sm={6}>
                                    <div className="flex flex-col">
                                        {/* <h4 className="text-lg">Download the App</h4> */}
                                        <p className="mt-4 mt-lg-0 mb-2 mb-sm-3">{downloadText}</p>
                                        <div className={`row ${styles.mtNe5}`}>
                                            {appLinks.map(({ href, icon, alt }, i) => (
                                                <div className="col-6 p-0 cursor-pointer" key={i}>
                                                    <a href={href} target="_blank" rel="noopener noreferrer nofollow">
                                                        <MyImage src={icon} alt={alt} height={41} width={110} className='mx-auto' />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
            {/* {
      isLoaded && width > 767 && (
        <PromotionSmall/>
      )
    } */}
        </footer>
  )
}

export default CommonFooter

CommonFooter.propTypes = {
  logo: PropTypes.any,
  sgMedia: PropTypes.any,
  description: PropTypes.string,
  links: PropTypes.array,
  socialLinks: PropTypes.array,
  appLinks: PropTypes.array,
  connectText: PropTypes.string,
  downloadText: PropTypes.string,
  CustomLink: PropTypes.any,
  MyImage: PropTypes.any,
  pageRouterComp: PropTypes.bool
}
